import {create} from "zustand";

import {mapPropertyCitationTypesTowableFromApi} from "../lib/citation-towable";
import {PropertyForm} from "../types";

type DetailsStoreState = {
  initialProperty: PropertyForm | null;
  property: PropertyForm | null;
};

type DetailsStoreActions = {
  initialize: (property: Omit<PropertyForm, "gate_codes_parsed">) => void;
  setProperty: (property: PropertyForm) => void;
  clearProperty: () => void;
};

export const useDetailsStore = create<DetailsStoreState & DetailsStoreActions>((set) => ({
  initialProperty: null,
  property: null,

  initialize: (property: Omit<PropertyForm, "gate_codes_parsed">) => {
    const gate_codes_parsed = property.gate_codes ? JSON.parse(property.gate_codes) : [];
    const citation_types = mapPropertyCitationTypesTowableFromApi(property.citation_types);
    set({
      initialProperty: structuredClone({
        ...property,
        gate_codes_parsed,
        citation_types,
      }),
      property: {
        ...property,
        gate_codes_parsed,
        citation_types,
      },
    });
  },
  setProperty: (property: PropertyForm) =>
    set({
      property: structuredClone(property),
    }),
  clearProperty: () => set({property: null, initialProperty: null}),
}));

export function useDetailsStoreProperty() {
  return useDetailsStore((state) => state.property);
}

export function useDetailsStoreInitialProperty() {
  return useDetailsStore((state) => state.initialProperty);
}

export function useDetailsStoreInitialize() {
  return useDetailsStore((state) => state.initialize);
}

export function useDetailsStoreSetProperty() {
  return useDetailsStore((state) => state.setProperty);
}

export function useDetailsStoreClearProperty() {
  return useDetailsStore((state) => state.clearProperty);
}
